import { render, staticRenderFns } from "./DropdownOptionsOptionLabels.vue?vue&type=template&id=0d2a345e&"
import script from "./DropdownOptionsOptionLabels.vue?vue&type=script&lang=js&"
export * from "./DropdownOptionsOptionLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports